import * as React from 'react';
import { StoryblokComponent } from 'gatsby-source-storyblok';
import FancyTitle from '../fancy-title';
import { loadPipedriveWebForms, onPageInteraction } from '../../lib/utils';

export default function SpecialistForm({ blok }) {
  const {
    title,
    subtitle,
    pipedriveFormId,
  } = blok;

  const formRef = React.useRef(null);

  React.useEffect(() => {
    if (!formRef.current) return undefined;

    return onPageInteraction(loadPipedriveWebForms);
  }, [pipedriveFormId]);

  return (
    <div id="specialist-form" className="bg-black py-[70px] px-8 lg:px-20 green-background-double">
      <FancyTitle
        text={title}
        subtitle={subtitle}
        textAlign="text-center lg:text-center"
        className="mx-auto text-white z-1 relative"
        marginBottom="mb-10"
        subtitleColor="green"
        tag="h2"
      />

      <div className="flex flex-wrap justify-center text-center mb-10 gap-12 text-white z-1 relative">
        {/* <div>
          <div>
            <img
              alt={image[0]?.alt || `${colleague} - ${position}`}
              className="rounded-full mb-4 max-w-[262px]"
              src={image[0].filename}
              width={400}
              height={400}
            />
          </div>
          {colleague}
          <br />
          {position}
        </div> */}

        {blok.persons?.map((person) => (
          <StoryblokComponent blok={person} key={person._uid} />
        ))}
      </div>

      <div
        id="contact-form-specialist"
        className="z-1 relative"
        ref={formRef}
        key={pipedriveFormId}
      >
        <div
          className="pipedriveWebForms h-auto"
          data-pd-webforms={`https://webforms.pipedrive.com/f/${pipedriveFormId}`}
        />
      </div>
    </div>
  );
}
